import React, { useState } from 'react';

import { motion, AnimatePresence } from 'framer-motion';

import Typography from '@mui/material/Typography';

import { fonts } from '../gatsby-theme-material-ui-top-layout/theme';

import styled from 'styled-components';

import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

import ArrowHorizontal from '../img/arrow-horizontal.svg';

import {
  PROPY_SPACE_GREY_LIGHT,
  PROPY_SPACE_GREY_SECONDARY,
  PROPY_BLACK,
} from '../utils';

const ZoneContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Zone = styled.div`
  max-width: 1080px;
  width: 100%;
`

const TypographyContainer = styled.div`
  max-width: 1060px;
  min-height: ${props => props.mobile ? "auto" : "342px"};
`

const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.mobile ? "center" : "end"};
  margin-top: ${props => props.mobile ? props.theme.spacing(2) : "0px"};
`

const TypographySpacer = styled.div`
  margin-top: ${props => props.theme.spacing(1.5)};
`

const TypographySpacerMini = styled.div`
  margin-top: ${props => props.theme.spacing(0.5)};
`

const articles = [
  {
    title: "Propy Awarded as Technology Pioneer by World Economic Forum",
    body: "Propy and its fellow pioneers are developing technologies that can help society solve some of its most pressing issues.",
    author: "Susan Nesbitt",
    org: "Head of the Global Innovators Community, WEF"
  },
  {
    title: "Three Ways Blockchain Technology Will Revolutionize Real Estate in 2019",
    body: "Propy is one of the most well-known incumbents in the space. It has built technology for buyers, sellers, brokers, title agents, and notaries to come together through a suite of smart contracts to facilitate transactions.",
    author: "",
    org: "Forbes",
    link: "https://www.forbes.com/sites/forbesrealestatecouncil/2018/11/15/three-ways-blockchain-technology-will-revolutionize-real-estate-in-2019/",
  },
  {
    title: "Most Innovative Real Estate Company",
    body: "Propy wants to streamline real estate transfers using technology. It successfully launched a blockchain pilot in Vermont to establish a secure digital process for delivering electronic deeds, placing it at the forefront of real estate companies leveraging blockchain.",
    author: "",
    org: "Inman",
    link: "https://www.inman.com/2022/12/15/so-meta-propy-offers-certification-in-virtual-world-real-estate/",
  },
  {
    title: "A blockchain-verified platform for selling houses",
    body: "...almost one-fifth of millennials have now thought about buying a home because of the lock-downs induced by the COVID-19 pandemic, meaning that many will be looking for an easy way to transact, especially if it has the ease of use Propy has.",
    author: "",
    org: "Tech Crunch",
    link: "https://techcrunch.com/2020/10/02/propy-a-blockchain-verified-platform-for-selling-houses-raises-funding-from-tim-draper/",
  },
  {
    title: "National Association of Realtors®’ VC Arm Invests in Propy",
    body: "Propy also integrated the favorite tools of agents such as DocuSign and addressed the main cybersecurity problem of the industry – wire fraud.",
    author: "",
    org: "RISMedia",
    link: "https://www.rismedia.com/2019/06/10/national-association-realtors-vc-arm-invests-propy-reach-program/"
  },
  {
    title: "TechCrunch Founder Sells $1.6 Million House",
    body: "Propy is a real estate transaction platform that empowers buyers, sellers, their agents, and escrow agents to close a traditional real estate deal entirely online. The purchase offer, payment, and deeds are uploaded to an immutable blockchain.",
    author: "",
    org: "Yahoo! Finance",
    link: "https://finance.yahoo.com/news/techcrunch-founder-sells-1-6-120038680.html",
  },
];

const textVariants = {
  enter: {
    x: 50,
    opacity: 0
  },
  center: {
    x: 0,
    opacity: 1
  },
  exit: {
    x: -50,
    opacity: 0
  }
};

const PioneerGallery = ({ isConsideredMobile }) => {

  const [currentIndex, setCurrentIndex] = useState(0);
  
  const handleNext = () => {
    // When we reach the end, loop back to the beginning
    setCurrentIndex(prev => 
      prev >= articles.length - 1 ? 0 : prev + 1
    );
  };

  const handlePrev = () => {
    // When we reach the beginning, loop to the end
    setCurrentIndex(prev => 
      prev <= 0 ? articles.length - 1 : prev - 1
    );
  };

  return (
    <ZoneContainer>
      <Zone>
        <TypographyContainer mobile={isConsideredMobile}>
           <Typography sx={{ fontFamily: fonts.spaceGrotesk, color: PROPY_SPACE_GREY_LIGHT, letterSpacing: '0.12em', textTransform: 'uppercase', textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '14px', lineHeight: '14px' }) }}>Research-backed Inventions</Typography>
           <TypographySpacer>
            <AnimatePresence mode="wait">
                <motion.div
                  key={currentIndex}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  variants={textVariants}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                >
                  <Typography 
                    variant="h4" 
                    sx={{ fontFamily: fonts.spaceGrotesk, color: PROPY_BLACK, letterSpacing: '-0.01em', maxWidth: isConsideredMobile ? 'none' : 900, textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '24px', lineHeight: '24px' }) }}
                  >
                    {articles[currentIndex].title}
                  </Typography>
                </motion.div>
              </AnimatePresence>
           </TypographySpacer>
           <TypographySpacer>
           <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                initial="enter"
                animate="center"
                exit="exit"
                variants={textVariants}
                transition={{ duration: 0.5, ease: "easeInOut", delay: 0.1 }}
              >
                <Typography 
                  variant="h5" 
                  sx={{ fontFamily: fonts.robotoSerif, color: PROPY_SPACE_GREY_SECONDARY, letterSpacing: '-0.01em', maxWidth: isConsideredMobile ? 'none' : 900, textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '24px', lineHeight: '24px' }) }}
                >
                  "{articles[currentIndex].body}"
                </Typography>
              </motion.div>
            </AnimatePresence>
           </TypographySpacer>
           <TypographySpacer>
            <TypographySpacer>
            <AnimatePresence mode="wait">
                <motion.div
                  key={currentIndex}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  variants={textVariants}
                  transition={{ duration: 0.5, ease: "easeInOut", delay: 0.2 }}
                >
                  <Typography 
                    sx={{ fontFamily: fonts.spaceGrotesk, color: PROPY_SPACE_GREY_LIGHT, fontWeight: 500, letterSpacing: '0.04em', fontSize: '14px', lineHeight: '15px', textTransform: 'uppercase', textAlign: isConsideredMobile ? 'center' : 'left'}}
                  >
                    {articles[currentIndex].author}
                  </Typography>
                  <TypographySpacerMini>
                    <Typography 
                      sx={{ fontFamily: fonts.spaceGrotesk, color: PROPY_SPACE_GREY_LIGHT, fontWeight: 400, letterSpacing: '0.04em', fontSize: '14px', lineHeight: '15px', textTransform: 'uppercase', textAlign: isConsideredMobile ? 'center' : 'left' }}
                    >
                      {articles[currentIndex].org}
                    </Typography>
                  </TypographySpacerMini>
                </motion.div>
              </AnimatePresence>
            </TypographySpacer>
           </TypographySpacer>
        </TypographyContainer>
        <Controls mobile={isConsideredMobile}>
          <IconButton
            onClick={handlePrev}
            sx={{
              border: '1px solid #38A6FB',
              height: '44px',
              width: '44px',
              marginRight: '8px',
              opacity: 1,
            }} 
            aria-label="backwards"
          >
            <Box
              component={ArrowHorizontal}
              sx={{
                width: '24px',
                height: '24px',
                color: 'primary.main',
                '& path': { fill: '#38A6FB' }
              }}
            />
          </IconButton>
          <IconButton
            onClick={handleNext}
            sx={{
              border: '1px solid #38A6FB',
              height: '44px',
              width: '44px',
              opacity: 1,
            }}
            aria-label="forwards"
          >
            <Box
              component={ArrowHorizontal}
              sx={{
                width: 24,
                height: 24,
                transform: 'rotate(180deg)',
                color: 'primary.main',
                '& path': { fill: '#38A6FB' }
              }}
            />
          </IconButton>
        </Controls>
      </Zone>
    </ZoneContainer>
  );
};

export default PioneerGallery;